import { usePathname, useSearchParams } from 'next/navigation';

// for app router
export const usePagePath = (witchSearchParams = true): string => {
    const searchParams = useSearchParams();
    const pathname = usePathname();

    return `${pathname}${witchSearchParams && searchParams?.size ? '?' + searchParams?.toString() : ''}`;
};
